import EditComponent from './AssetStatusEdit';
import WebUniversal, { WUExtendPropsType } from '../../system/WebUniversalNewEx'
import { columnsheadId } from '../../universal/columnshead';

//组件 
const WebComponents = (props: any) => {

    /** api服务id */
    const apiId = 'assetStatus';

    //表头
    const columnsHead = [
        {
            title: '资产状态',
            dataIndex: 'assetStatusName'
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '资产状态',
        apiId,
        columns,
        showStates: true,
        pagination: true,
        EditComponent
    };

    return (
        <WebUniversal props={extendProps} />
    )
}

export default WebComponents;
